const cleanUrlPart = value => String(value || '').trim();
const MEMBERSHIP_PAYMENT_LOGIN_CHECK_KEY = 'cf_membership_payment_login_checked';

const sessionStorage = () => {
  if (typeof window === 'undefined') return null;

  return window.sessionStorage;
};

export const membershipPaymentLoginCheckCompleted = () =>
  sessionStorage()?.getItem(MEMBERSHIP_PAYMENT_LOGIN_CHECK_KEY) === '1';

export const markMembershipPaymentLoginCheckCompleted = () => {
  sessionStorage()?.setItem(MEMBERSHIP_PAYMENT_LOGIN_CHECK_KEY, '1');
};

export const resetMembershipPaymentLoginCheck = () => {
  sessionStorage()?.removeItem(MEMBERSHIP_PAYMENT_LOGIN_CHECK_KEY);
};

export const membershipPaymentRecoveryUrl = paymentAttention => {
  if (!paymentAttention) return '';

  const recoveryUrl = cleanUrlPart(paymentAttention.recoveryUrl);
  if (recoveryUrl) return recoveryUrl;

  const planId = cleanUrlPart(paymentAttention.planId);
  const subscriberId = cleanUrlPart(paymentAttention.subscriberId);
  if (!planId || !subscriberId) return '';

  const params = new URLSearchParams({
    subscriberId,
    paymentIssue: '1',
  });
  const companyId = cleanUrlPart(paymentAttention.companyId);
  if (companyId) params.set('companyId', companyId);

  return `/memberships/${encodeURIComponent(planId)}?${params.toString()}#membership-cards`;
};
